import React, { Component } from 'react';
import some from 'lodash/some';
import isEmpty from 'lodash/isEmpty';
import { FormGroup, TextInput, PagerButtons } from 'sure-components';
import * as analytics from 'shared/lib/analytics';
import PlanDisclaimer from 'shared/lib/components/PlanDisclaimer';
import PropTypes from 'prop-types';
import './BaggagePassengerDetailsView.css';

const propTypes = {
  account: PropTypes.object,
  baggagePassengerInfo: PropTypes.object,
  disclaimer: PropTypes.string,
  saveBaggagePassengerInfo: PropTypes.func,
  navTo: PropTypes.func,
};

const defaultProps = {
  account: {},
  disclaimer: null,
};

class BaggagePassengerDetailsView extends Component {
  componentDidMount() {
    analytics.page('BRB - Passenger Info');
    this.props.saveBaggagePassengerInfo({
      firstName: this.props.account.firstName,
      lastName: this.props.account.lastName,
      email: this.props.account.email,
      phone: this.props.account.phoneNumber,
    });
  }

  handleFormChange = e => {
    this.props.saveBaggagePassengerInfo({
      [e.target.name]: e.target.value || '',
    });
  };

  handleBack = () => {
    this.props.navTo('/baggage-protection/flight');
  };

  handleNext = e => {
    if (e) {
      e.preventDefault();
    }
    analytics.identify({
      email: this.props.baggagePassengerInfo.email,
    });
    this.props.navTo('/baggage-protection/plans');
  };

  isNextDisabled() {
    const requiredFields = [
      this.props.baggagePassengerInfo.firstName,
      this.props.baggagePassengerInfo.lastName,
      this.props.baggagePassengerInfo.email,
      this.props.baggagePassengerInfo.phone,
    ];

    return some(requiredFields, isEmpty);
  }

  render() {
    return (
      <div className="BaggagePassengerDetailsView Container Container--small">
        <h1 className="BaggagePassengerDetailsView-heading">
          Add your passenger info as it shows on your boarding pass
        </h1>
        <form
          className="BaggagePassengerDetailsView-form"
          onChange={this.handleFormChange}
          onSubmit={this.handleNext}
        >
          <FormGroup>
            <label>Passenger Details</label>
            <TextInput
              name="firstName"
              placeholder="First Name"
              required
              value={this.props.baggagePassengerInfo.firstName || ''}
              onChange={this.handleFormChange}
            />
            <TextInput
              name="middleName"
              placeholder="Middle Name (optional)"
              value={this.props.baggagePassengerInfo.middleName || ''}
              onChange={this.handleFormChange}
            />
            <TextInput
              name="lastName"
              placeholder="Last Name"
              required
              value={this.props.baggagePassengerInfo.lastName || ''}
              onChange={this.handleFormChange}
            />
            <TextInput
              name="email"
              type="email"
              placeholder="Email Address"
              required
              value={this.props.baggagePassengerInfo.email || ''}
              onChange={this.handleFormChange}
            />
            <TextInput
              name="phone"
              type="tel"
              placeholder="Mobile Number"
              required
              value={this.props.baggagePassengerInfo.phone || ''}
              onChange={this.handleFormChange}
            />
          </FormGroup>
          <input type="submit" style={{ display: 'none' }} />
          <PagerButtons
            className="BaggagePassengerDetailsView-cta"
            onBack={this.handleBack}
            onNext={this.handleNext}
            isNextDisabled={this.isNextDisabled()}
          />
        </form>
        <PlanDisclaimer text={this.props.disclaimer} />
      </div>
    );
  }
}

BaggagePassengerDetailsView.propTypes = propTypes;
BaggagePassengerDetailsView.defaultProps = defaultProps;

export default BaggagePassengerDetailsView;
